const validate = (value, rules) => ({
  error: rules && value.length > rules.max ? 'MAXIMUM_CARD_NUMBER_LENGTH' : '',
});

export default validate;
